import React from 'react'
import {
  Box,
  Card,
  CardBody,
  Heading,
  VStack,
  Spinner,
  useDisclosure,
} from '@chakra-ui/react'
import { useParams } from 'react-router-dom'
import useCanManageResearch from '../../../hooks/useCanManageResearch'
import { useResearchDetails } from './hooks/useResearchDetails'
import {
  ResearchTagList,
  DeleteResearchDialog,
} from '../../../components/research'
import ResearchDetailHeader from './components/ResearchDetailHeader'
import ResearchPublicationInfo from './components/ResearchPublicationInfo'
import ResearchContent from './components/ResearchContent'

const ResearchDetailsPage = () => {
  const { id } = useParams<{ id: string }>()
  const canManageResearch = useCanManageResearch()
  const { research, tags, loading, error } = useResearchDetails(id)
  const { isOpen, onOpen, onClose } = useDisclosure()

  if (loading) {
    return (
      <Box
        p={6}
        display='flex'
        justifyContent='center'
        alignItems='center'
        minH='200px'
      >
        <Spinner size='xl' />
      </Box>
    )
  }

  if (error || !research) {
    return null // Will redirect
  }

  return (
    <Box p={6} maxW='4xl' mx='auto'>
      <ResearchDetailHeader
        canManageResearch={canManageResearch}
        researchId={id!}
        onDelete={onOpen}
      />

      <Card>
        <CardBody>
          <VStack align='start' spacing={6}>
            {/* Title */}
            <Heading size='lg' lineHeight='1.3'>
              {research.title}
            </Heading>

            <ResearchPublicationInfo research={research} />
            <ResearchContent research={research} />
            <ResearchTagList tagIds={research.tags} tags={tags} />
          </VStack>
        </CardBody>
      </Card>

      <DeleteResearchDialog
        isOpen={isOpen}
        onClose={onClose}
        researchId={id!}
        researchTitle={research.title}
      />
    </Box>
  )
}

export default ResearchDetailsPage
